import   React,
       { useEffect,
         useState,
         useContext } from 'react';
import { withRouter,
         Redirect } from 'react-router-dom';
import { Button,
         Link,
         Fade,
         Typography,
         Drawer,
         List,
         ListItem,
         ListItemText,
         ListItemIcon, 
         Divider,
         Container } from '@material-ui/core';
import { makeStyles,
         } from '@material-ui/core/styles';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars,
         faRedoAlt,     // refresh
         faSun,         // today
         faDumbbell,    // condition
         faHandPointer, // agility
         faBullseye,    // skill
         faTachometerAlt, // challenge
         faFilm,
         faSyncAlt } from '@fortawesome/free-solid-svg-icons';     //icons: https://fontawesome.com/icons
import { DirectionsRunIcon,
         Timer } from '@material-ui/icons';

import { GATag,
         test2ConeRandom } from "../util/tools";
import { getTutorial,
         days_from_epoch,
         setScreenOrientation,
         processServiceWorkerReload,
         } from '../util/util';
import { appContext } from "./index";
import { VIMEO_POST } from "../util/constants";
import   Tutorial  from "./Tutorial";
import { AuthClass } from '../class/AuthClass';
import { Avatar, 
         Reload, 
         Wait, 
         Settings,
         NewsFeed,
         LeaderBoard,
         DailyScore, 
         NoticePWA,
         TypeIcon,
         UTIL_useStyles } from './Util';

import { VideoFeed } from "./VideoPlayer";
import { arrayOwnerHashAscSort,
         setupScheme,
         loadUserState,
         arrayTargetHashAscSort,
         processLeaderItems,
         processStateItems, } from "../util/util";
//import { recordVimeoStream } from '../util/database';      // testing only
import { UtilClass } from '../class/UtilClass';
import { INFO, CONSTS } from '../util/object';
import { AXOS_VERSION } from '../version';
import { makeUserKey,
         ReadLeaderData,
         ReadStateData,
        } from '../util/database';

import Game from "./Game";

//import { LoadingBars  } from '../util/spinner'; 
//import { BarGraph } from "./Graph";

//import clsx from 'clsx';
//import Divider from '@material-ui/core/Divider';
//import InboxIcon from '@material-ui/icons/MoveToInbox';
//import MailIcon from '@material-ui/icons/Mail';


var auth = new AuthClass();
const Util = new UtilClass();

const auth_useStyles = makeStyles(theme => ({
    menu_root: {
        display: 'flex',
        //display: 'none',
        //flexDirection: 'row',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignContent: 'flex-start',
        height: '100%',
        width: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
        marginTop: '50px',      // '10vh',
        padding: "0",
        overflow: 'auto',
        //backgroundColor:'#44ffff',
    },

    dashboard_container: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignContent: 'flex-start',
        width: '100%',
        height: '100%',
        overflow: 'auto',
        //backgroundColor:'#44ffff',
    },

    horizontal_dashboard_container: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignContent: 'flex-start',
        width: '100%',
        //height: 'calc(100% - 60px)',
        height: '100%',
        width: 'calc(100% - 60px)',
        maxHeight: '100%',
        maxWidth: '100%',
        margin: '0',
        //marginTop: '10vh',
        padding: "0",
        overflow: 'hidden',
        //backgroundColor:'#44ffff',
    },
    vertical_dashboard_container: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignContent: 'flex-start',
        height: 'calc(100% - 60px)',
        width: '100%',
        //height: '100%',
        //width: 'calc(100% - 60px)',
        maxHeight: '100%',
        maxWidth: '100%',
        margin: '0',
        padding: "0",
        //overflow: 'auto',
        overflow: 'hidden',
        //backgroundColor:'#44ffff',
    },

    menu_button: {
        "&:hover": {
            color: 'yellow',
            backgroundColor: '#3b58c1',
            borderColor: 'rgba(255,255,255,0)',
        },
		fontSize: '1.2rem',
        //minWidth: '180px',
        width: '30vw',
        maxWidth: '180px',      // 160px
        minWidth: '130px',      // 160px

        height: '15vh',
        maxHeight: '85px',
        minHeight: '50px',

        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '0.5vh',
        marginBottom: '3vh',
        padding: '10px',
        //backgroundColor: 'rgba(20, 70, 162, 0.9)',
        backgroundColor: 'rgba(43, 65, 120, 0.95)',     // Dark Cornflower Blue
        color: 'white',
        borderColor: 'rgba(255,255,255,0)',
        borderRadius: '15px',
        border: '0px',
        //boxShadow: '0 10 20 0',
        alignItems: 'center',
        justifyContent: 'center',
    },
    top_bar: {
        display: "flex",
        position: 'absolute',
        top: '0',
        right: '0',
        height: "50px",
        width: "100%",
        maxWidth: '100%',
        padding: '2px',
        paddingBottom: '0px',
        justifyContent: 'space-between',
        zIndex: '500',
        //boxShadow: "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px"
        boxShadow: "rgba(0, 0, 0, 0.09) 0px 2px 2px",
    },
    right_bar: {
        display: "flex",
        height: "calc(100vh - 50px)",
        width: "60px",
        maxWidth: '100%',   // 100vw
        padding: '0',       //'30px 0',
        margin: '0',
        //marginTop: '10px',
        marginTop: '0px',
        justifyContent: 'space-between',
        backgroundColor: '#2b417873',
    },
    bottom_bar: {
        display: "flex",
        height: "60px",     //"80px",
        width: "100vw",
        margin: '0',
        padding: '0 30px',
        maxWidth: '100vw',
        justifyContent: 'space-between',
        backgroundColor: '#2b417873',
    },

    all_buttons_bar: {
        display: "flex",
        flexDirection: 'row',
        //height: "100vh",
        height: 'calc(100vh - 60px)',
        marginLeft: 'auto',
        marginRight: 'auto',
        justifyContent: 'center',
        overflow: 'auto',
    },
    button1_bar: {
        display: "flex",
        flexDirection: 'column',
        top: '0',
        bottom: '0',
        height: "96%",
        //height: 'calc(100vh - 50px)',
        //maxHeight: "500px",
        //width: "40vw",
        //width: "auto",
        //maxWidth: "40%",
        width: "50%",
        padding: '6px',
        paddingBottom: '3vh',
        margin: '0px',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    button2_bar: {
        display: "flex",
        flexDirection: 'column',
        height: "100%",
        width: "90%",
        padding: '6px',
        alignContent: 'flex-start',
        margin: 'auto',
        //margin: '0px',
        //top: '0',
        //bottom: '0',
        //width: "30vw",
    },
    button3_bar: {
        display: "flex",
        flexDirection: 'column',
        top: '0',
        bottom: '0',
        height: "100vh",
        //width: "30vw",
        //width: "auto",
        width: "50%",
        padding: '6px',
        alignContent: 'flex-start',
        margin: '0px',
    },
    top_center: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: 'auto',
        alignSelf: 'center',
    },
    logout_link: {
		fontSize: '1.1rem',
        //height: '18vh',
        //width: '20vh',
        minWidth: '280px',
        paddingBottom: '3vh',
        textAlign: 'center',
        //marginTop: '10vh',
    },
    anon_text: {
		fontSize: '1.3rem',
        justifySelf: 'center',
        textAlign: 'center',
        color: 'rgb(250,0,0,0.9)',
        marginBottom: '1vh',
        minWidth: '400px',
    },

    org_text: {
        fontWeight: 'bold',
		fontSize: '1.1rem',
        color: '#313180f5',
        justifySelf: 'center',
        textAlign: 'center',
    },

    vertical_org_text: {
        fontWeight: 'bold',
		fontSize: '1.0rem',
        color: '#313180f5',
        justifySelf: 'center',
        textAlign: 'center',
    },

    horizontal_org_text: {
        fontWeight: 'bold',
		fontSize: '1.5rem',
        color: '#313180f5',
        justifySelf: 'center',
        textAlign: 'center',
    },

    version_text: {
        //height: '18vh',
		fontSize: '0.75rem',
        color: 'rgb(180,180,300,0.9)',
        justifySelf: 'center',
        textAlign: 'center',
    },


    menu_label: {
        //height: '18vh',
        //justifySelf: 'center',
		fontSize: '1.0rem',
        color: '#8181a5e6',
        textAlign: 'start',
        margin: '0px 0 -8px 0',
        //paddingLeft: '15px',
    },

    menu_button: {
        padding: "8px 15px", 
    },

    menu_text: {
		fontSize: '0.88rem',
        textAlign: 'start',
        padding: '0 5px 0 5px',
        color: '#666',
        verticalAlign: 'middle',
    },

    menu_icon: {
        margin: '0 0 0 10px', 
        padding: '0', 
        minWidth: '0',
        width: '24px',
        height: '24px',
    },

    menu_icon1: {
        width: "22px", 
        height: "auto", 
        padding: "0", 
        marginRight: "8px",
    },

    graph_container: {
        display: 'flex',
        flexDirection: 'column',
        //width: "85vw",
        width: "40vw",
        //maxWidth: "300px",
        minHeight: "150px",
        border: '2px dashed #283c2773',
        margin: "10px auto",
        overflow: 'auto',
        padding: "5px",
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.55) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        backgroundColor: 'rgba(230, 230, 230, 0.99)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        height: "100%",     // used for default
        color: "#999",
    },
    graph_leader: {
        height: "25vh",
        //height: "100px",
        overflow: 'hidden',
    },
    graph_20h: {
        height: "20vh",
    },
    graph_30h: {
        height: "30vh",
        minHeight: '200px',
    },
    graph_40h: {
        height: "30vh",
    },
    graph_90w: {
        width: "90vw",
    },
    graph_90h: {
        height: "90%",
    },
    leader_container: {
        display: 'flex',
        width: "85vw",
        height: "30vh",
        border: '2px dashed #ff000030',
        margin: "10px auto",
        padding: "40px",
        color: "#999",
    },

}));



export const Menus = (props) => {
    const classes = auth_useStyles();
    const [ Menus, setMenus ] = useState([]);

    useEffect(() => {
        if(INFO.menu_keys !== null) {
            //console.log("menu.204:  DB MENU KEY ", INFO.menu_keys);
            var db = INFO.menu_data;
            var keys = INFO.menu_keys;
            var menus = [];

            function walkDashboardTree(menus, field, sub) {
                if ((keys === undefined) || (keys[field] === undefined)) return menus;

                var tops = (keys[field] !== undefined) ? keys[field] : [];
                //console.log("menu.253: ....field=",field, "  val=",tops, "  menus=", menus);

                for(var i = 0; i < tops.length; i++) {
                    var bits = tops[i].split("+");
                    var hash = bits[0];
                    var menu0 = db.filter(m => { return m.hash == hash });
                    var menu = menu0[0];
                    var type = (menu) ? menu.type : null;

                    menu.sub = sub;
                    //console.log("menu.209:       ",sub, "   ", menu.name, " ", menu.type, " menus=",menus)
                    if(bits.length > 1) {
                        menu.type = "label";
                        menus.push(menu);
                        //console.log("menu.217:              DISPLAY SUB MENU HERE  ", menu.name, " ", menu.type)
                        menus = walkDashboardTree(menus, hash, sub+1);       // has sub-menu
                    } else {
                        // verify there are items in the category
                        //
                        var match = INFO.db_drills.filter(d => {return (d.type == type)})
                        if (match.length > 0) {
                            menus.push(menu);
                        } else {
                            console.log("menu.455:          SKIP MENU ",hash, " type=",type);
                        }
                    }
                }
                //console.log("menu.268: ...",field, "  RETURN menus=",menus);
                return menus;
            }
            menus = walkDashboardTree(menus, "top", 0);
            //console.log("menu.269:  FINAL menus=",menus);
            setMenus(menus);
        }
    }, [1]);


    const handleAction = (cmd) => event => {
        console.log("handle_action:278:  cmd=",cmd);        // , "  props.Action=", props.Action);
        props.Action(cmd);
    }
        

                        //{(menu.sub > 0) && <Spacer Width={"20px"} />}
                    //{(false && (menu.sub > 0)) ?  <Spacer key={"spc_"+index} Width={"20px"} /> : ""}
                    //<ListItem button key={"btn_"+index} style={{paddingLeft: (menu.sub * 25) + "px"}} onClick={handleAction(menu.name)}></ListItem>

    return (
        <div className={classes.drawer_list}
            role="presentation"
            onClick={props.Toggle(false)}
            onKeyDown={props.Toggle(false)} >

        <List>
            {Menus && Menus.map((menu, index) => (
                (menu.type == "label") ?
                    <ListItem key={"lst_"+index} style={{paddingLeft: "10px"}} >
                        <Typography key={"menu_"+index} className={classes.menu_label}>
                            {menu.name.toUpperCase()}
                        </Typography>
                    </ListItem>
                :
                    <ListItem button key={"btn_"+index} className={classes.menu_button} style={{paddingLeft: (menu.sub * 16) + "px"}} onClick={handleAction(menu.type)}>
                        <ListItemIcon className={classes.menu_icon}>
                            <TypeIcon Type={menu.type} className={classes.menu_icon1} />
                        </ListItemIcon>
                        {/*<ListItemText key={"txt_"+index} className={classes.menu_text} style={{fontSize: "0.7rem"}} primary={menu.name.toUpperCase()} />*/}
                        <div key={"txt_"+index} className={classes.menu_text}> {menu.name.toUpperCase()} </div>
                    </ListItem>
                ))}
        </List>

        <Divider />

        </div>
    )
};



const quick_launch_useStyles = makeStyles(theme => ({
    launch_container: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: "space-around",
        alignContent: "space-around",
        width: '100%',
        height: '100%',
        margin: '0',
        padding: '0',       // '0 0 15px 0',
        border: '0px',
        zIndex: '500',
    },
    launch_button: {
        display: 'flex',
        width: '45px',
        height: '45px',
        margin: '0',
        padding: '0',
        //margin: '4px',
        //padding: '5px 5px',
        minWidth: '10px',
        borderRadius: '50%',
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.55) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        backgroundColor: '#2b4178f2',
        //background: '#0f0',
    },
    launch_icon: {
        color: '#cccccc',
        //paddingTop: '5px',
    }
}));


// shortcut launch buttons
//
export const QuickLaunch = (props) => {
    const classes = quick_launch_useStyles();
    const Classes = UTIL_useStyles();
    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        //console.log("setState:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });   // reducer wrapper
    }
    const [ StartDisplay, setStartDisplay ] = useState(true);
    return (
        <React.Fragment>
            <Container className={classes.launch_container}>
                <Button className={classes.launch_button} onClick={props.Action1}>
                    <FontAwesomeIcon className={classes.launch_icon} icon={props.Icon1} style={{width: "1.7rem", height: "1.7rem"}} />
                </Button>
                <Button className={classes.launch_button} onClick={props.Action2}>
                    <FontAwesomeIcon className={classes.launch_icon} icon={props.Icon2} style={{width: "1.7rem", height: "1.7rem"}} />
                </Button>
                <Button className={classes.launch_button} onClick={props.Action3}>
                    <FontAwesomeIcon className={classes.launch_icon} icon={props.Icon3} style={{width: "1.7rem", height: "1.7rem"}} />
                </Button>

            </Container>
        </React.Fragment>

    )
}





// Display top level menu
export const Dashboard = (props) => {
    const classes = auth_useStyles();
    const Classes = UTIL_useStyles();
    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        //console.log("setState:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });   // reducer wrapper
    }
    //const [ StartDisplay, setStartDisplay ] = useState(true);
    const [ Target, setTarget ] = useState("");
    const [ TestStarted, setTestStarted ] = useState(false);
    const [ ShowWait, setShowWait ] = useState(false);
    const [ ShowWaitSpinner, setShowWaitSpinner ] = useState(false);
    const [ Show, setShow ] = useState(null);
    const [ ShowTutorial, setShowTutorial ] = useState(false);
    const [ ShowTrainDashboard, setShowTrainDashboard ] = useState(false);
    const [ Version, setVersion ] = useState("");
    const [ HealthLightColor, setHealthLightColor ] = useState("grey");
    const [ Warning, setWarning ] = useState("");     // warning msg
    const [ OrgName, setOrgName ] = useState("");
    const [ Photo, setPhoto ] = useState("");     // warning msg
    const [ News, setNews ] = useState([]);     // warning msg
    const [ LeaderBoards, setLeaderBoards ] = useState([]);     // warning msg
    const [ LeaderBoardHeight, setLeaderBoardHeight ] = useState(null);     // warning msg
    const [ NewsBoardHeight, setNewsBoardHeight ] = useState(null);     // warning msg
    const [ ScoreBoardHeight, setScoreBoardHeight ] = useState(null);     // warning msg
    const [ VideoBoardHeight, setVideoBoardHeight ] = useState(null);     // warning msg
    const [ DailyScores, setDailyScores ] = useState([]);     // warning msg
    const [ VideoFeeds, setVideoFeeds ] = useState([]);     // warning msg
    const [ NoticeType, setNoticeType ] = useState(null);
    const [ Refresh, setRefresh ] = useState(0);
    const [ MenuDrawerOn, setMenuDrawerOn ] = useState(false);
    const [ SettingDrawerOn, setSettingDrawerOn ] = useState(false);
    const [ CurrentScore, setCurrentScore ] = useState(0);
    const [ VideoShowcase, setVideoShowcase ] = useState(null);
    const [ GameScheme, setGameScheme ] = useState([]);   // game setting
    const [ GameFingers, setGameFingers ] = useState(1);   // game setting
    //const [ GameStarted, setGameStarted ] = useState(false);   // game setting
    const [ GameClicks, setGameClicks ] = useState([]);   // game setting
    const [ ShowPWA, setShowPWA ] = useState(false);
    const [ PWAShowed, setPWAShowed ] = useState(false);

    const [ LeaderExpandMode, setLeaderExpandMode ] = useState(false);   // game setting
    const [ NewsExpandMode, setNewsExpandMode ] = useState(false);   // game setting
    const [ ScrollToBottom, setScrollToBottom ] = useState(0);   // force scroll after card expanded


    useEffect(() => {
        INFO.tut_module = "dashboard";
        INFO.tut_op = "start";
        var show = getTutorial(INFO.tut_module, INFO.tut_op);
        if(show !== null) {
            setShow(show);
            setShowTutorial(true);
        }

        console.log("dash.204:     ###############  REACHED DASHBOARD ++++++++++++++++  invite_key=",INFO.invite_key);
        //INFO.setState = setState;   // need to set it here for the event handler calls to get back to React state
        //INFO.State = State;

        setShowWaitSpinner(false);
        setShowTrainDashboard(false);
        setupDashboardData();

        var pwa_state = INFO.pwa_install_state;
        console.log("pwa.638:  pwa_state=",pwa_state);
        if (false || (pwa_state === CONSTS.PWA_ADD_IOS_HOME ) || (pwa_state === CONSTS.PWA_ADD_ANDROID_HOME)) {
            if ((PWAShowed === false) && (INFO.pwa_showed === false)) {
                //setNoticeType(CONSTS.PWA_ADD_ANDROID_HOME); {
                setNoticeType(pwa_state);
                setShowPWA(true);
                setPWAShowed(true);
                INFO.pwa_showed = true;
            }
        }


        window.addEventListener('show_warning', handleShowWarning, false); // Listen for the event.
        window.addEventListener('health_light', handleHealthLight, false); // Listen for the event and write session to fb
        window.addEventListener('has_news', handleNewsEvent, false); // redirect to /auth
        return function cleanup() {
            console.log("dash.391:     ###############  LEAVING DASHBOARD ---------------  ");
            window.removeEventListener('show_warning', handleShowWarning, false); // Listen for the event.
            window.removeEventListener('health_light', handleHealthLight, false); // Listen for the event and write session to fb
            window.removeEventListener('has_news', handleNewsEvent, false); // redirect to /auth
        };

    }, [1]);


    useEffect(() => {
        console.log("Dashboard.62:   Dashboard Refresh  * * * *  Photo=",props.Photo, "  CurrentScore=",CurrentScore, " ShowWait=",ShowWait);
        if (typeof(props.Photo) == "string") {
            setPhoto(props.Photo);
        }
    }, [Refresh, props.Photo, CurrentScore, Warning]);


    useEffect(() => {
        var org_name = "AXOS SPORTS";
        if ((INFO.db_org !== undefined) && (INFO.db_org !== null)) {
            org_name = INFO.db_org.name.toUpperCase();
        }
        setOrgName(org_name);

    }, [INFO.db_org]);


    useEffect(() => {
        console.log("Dashboard.640:   Dash Loading Data  ",props.Reload);
        setupDashboardData();
    }, [ props.Reload]);


    // auto scroll down
    //
    useEffect(() => {
        var div = document.getElementById("dashboard_inner");
        console.log("Dashboard.643:   Force SCROLL to Bottom ", div.scrollHeight);
        //div.scrollTo(0,  height);
        div.scrollTop = div.scrollHeight;
    }, [ ScrollToBottom]);


    useEffect(() => {
        var leader_div, height;
        if(LeaderExpandMode === false) {
            leader_div = document.getElementById('leaderboard');
            height =  leader_div ? leader_div.offsetHeight : 0;
        } else {
            leader_div = document.getElementById('dashboard_container');
            if(props.VerticalMode === true) {
                height =  leader_div.offsetHeight - 85;     // 55
            } else {
                height =  leader_div.offsetHeight - 35;
            }
        }

        if ((leader_div !== null) && (leader_div !== undefined)) { 
            setLeaderBoardHeight(height);
            console.log("effect.651:  SET LEADER HEIGHT()....contract=",height, "  base=",leader_div.offsetHeight);
        }

        setScrollToBottom(ScrollToBottom + 1);

    }, [ LeaderExpandMode ]);



    useEffect(() => {
        console.log("735.dash:   DASHBOARD NEWS UPDATE  News=",News)
    }, [ News ]);

    useEffect(() => {
        var leader_div, height;
        if(NewsExpandMode === false) {
            leader_div = document.getElementById('news_feed');
            height =  leader_div.offsetHeight;
        } else {
            leader_div = document.getElementById('dashboard_container');
            if(props.VerticalMode === true) {
                height =  leader_div.offsetHeight - 35;
            } else {
                height =  leader_div.offsetHeight - 15;
            }
        }

        if ((leader_div !== null) && (leader_div !== undefined)) { 
            setNewsBoardHeight(height);
            console.log("effect.651:  SET NEWS HEIGHT()....contract=",height);
        }

        setScrollToBottom(ScrollToBottom + 1);

    }, [ NewsExpandMode ]);


    const handleDismissTutorial = () => {
        console.log("menu.92: ----->  REACHED HANDLE_DISMISS_TUTORIAL");
        setShowTutorial(false);
    }


    // init routine
    //
    function setupDashboardData() {
        setVersion(AXOS_VERSION);
        setupLeaderboardData();
        setupScoreData();
        setupGameReplayData();
        setupVideoFeedData();
        setHealthLightColor(INFO.health_light_color);
    }

    // read and process leader boards
    //
    const setupLeaderboardData = () => {
        var user_key = makeUserKey(INFO.email, "setupLeaderboardData.720");

        if ((INFO.db_leaders === null) || (INFO.db_leaders === undefined)) {
            setTimeout(()=> {
                setupLeaderboardData();     // wait then check again
            },  CONSTS.DB_RECHECK_INTERVAL);
            return;
        }

        var leader_div = document.getElementById('leader_board');
        if ((leader_div !== null) && (leader_div !== undefined)) { 
            var height =  leader_div.offsetHeight;
            setLeaderBoardHeight(height);
        }

        //console.log("lead.445:  PRE-SORT  ",INFO.db_leaders);
        INFO.db_leaders.sort(arrayTargetHashAscSort);
        setLeaderBoards(INFO.db_leaders);
        //INFO.db_leaders = processLeaderItems("leader", INFO.db_leaders);
    }


    // read and process video-of-the-day
    //
    const setupVideoFeedData = () => {
        var user_key = makeUserKey(INFO.email, "setupVideoFeedData.745");

        /*
        // TODO: NEED TO GET VOD FROM SERVER!
        var vimeo_post = "?autoplay=1&amp;loop=1&amp;autopause=1&amp;muted=1&amp;controls=0";
        var vids = [ {url: "https://player.vimeo.com/video/584076240" + vimeo_post, title:  "TIC-TOC-ROLL", drill_hash: "drl:axos:ttr1:1"},
                     {url: "https://player.vimeo.com/video/575200977" + vimeo_post, title:  "2-CONES-BALL", drill_hash: "drl:axos:2cwb:1"},
                     {url: "https://player.vimeo.com/video/575198644" + vimeo_post, title:  "BERLIN SHUFFLE", drill_hash: "drl:axos:berln:1"} ]

        console.log("vod.709:       SETUP VOD VIDEOS   ", vids);
        setVideoShowcase(vids)
        */

        var video_div = document.getElementById('video_board');
        if ((video_div !== null) && (video_div !== undefined)) { 
            var height =  video_div.offsetHeight;
            setVideoBoardHeight(height);
        }

    }

    // read and process other player news feed
    //
    const setupNewsFeedData = () => {
        var user_key = makeUserKey(INFO.email, "setupNewsFeedData.769");

        if ((INFO.db_leaders === null) || (INFO.db_leaders === undefined)) {
            ReadLeaderData(user_key)
            .then(leaders => {
                INFO.db_leaders = processLeaderItems(leaders);
            })
        } else {
            INFO.db_leaders.sort(arrayTargetHashAscSort);
            //INFO.db_leaders = processLeaderItems("leader", INFO.db_leaders);
            console.log("dash.396: ********  NewsFeeds =", INFO.db_leaders);
            var last_target = null;
            for(var i = 0; i < INFO.db_leaders.length; i++) {
            }
        }

        //setNewsFeeds(INFO.db_newsfeed);
    }


    // get data needed to simulate a game replay
    //
    const setupGameReplayData = () => {

        if ((INFO.db_motions !== null) && (INFO.db_motions !== undefined)) {
            var motion_hash = "mot:axos:test:1"
            var schemes = setupScheme(motion_hash, 6000, 500);
            setGameScheme(schemes);              // target sequence

            var clicks = [];
            clicks[0] ={ delay: 810, x: 100, y: 100};
            clicks[1] ={ delay: 600, x: 210, y: 120};
            clicks[2] ={ delay: 500, x: 140, y: 150};
            clicks[4] ={ delay: 700, x: 200, y: 80};
            setGameClicks(clicks);              // target sequence
            console.log("dash_replay_game.519:  DASH schemes=",schemes);
        } else {
            // KLDUGE: DISABLE FOR NOW UNTIL WE NEED IT
            //console.log("dash_replay_game.629:  ..............WAIT, DB_MOTION NOT READY   ", Date.now());
            //setTimeout(setupGameReplayData, 1000);     // wait and check again
        }
    }



    /// UTIL: sort array based on sequence
    function arrayDayAscSort(a, b) {
        if (a.day == b.day) {
            return 0;
        }
        else {
            return (a.day < b.day) ? -1 : 1;
        }
    }



    // process scores
    //
    var sconsole_log = (false) ? console.log : () => {};		// true will disable console.log
    function processScoreDisplay() {
        var scores = [], all_scores = [];

        for(var i = 0; i < INFO.db_scores.length; i++) {
            var score = INFO.db_scores[i];
            var k = 0;
            //sconsole_log("score.427:   ******** ",i,"   ",score.sltart_day, "    ",Object.keys(score).length,"   base=",score.end_base, " lbonus=",score.end_lbonus, "   pbonus=",score.end_pbonus, "    ",score.end_score);
            for (var day in score) {
                if (parseInt(day) > 18000) {        // 1625000000000) 
                    //sconsole_log("score.430:        ",k,"     ",score[day].epoch_day,"   base=",score[day].base, " lbonus=",score[day].lbonus, "   pbonus=",score[day].pbonus, "   score= ",score[day].score);
                    var item = {}
                    item.day = parseInt(score[day].epoch_day);
                    item.base = score[day].base;
                    item.lbonus = score[day].lbonus;
                    item.pbonus = score[day].pbonus;
                    item.score = score[day].score;
                    if(item.day > 0) {
                        scores.push(item);
                        k = k + 1;
                    }
                }
            }
            if(score.end_score > INFO.current_score) {
                INFO.current_score = score.end_score;
            }
            setCurrentScore(INFO.current_score);
        }
        console.log("dash.414: ********  User Scores    current_score=",INFO.current_score, "  ",INFO.db_scores);


        if (scores.length === 0){
            var score_div = document.getElementById('score_board');
            if ((score_div !== null) && (score_div !== undefined)) { 
                var height =  score_div.offsetHeight;
                setScoreBoardHeight(height);
            }
            setDailyScores([]);
        }

        // dumps out the LAST X days from the end
        //
        scores.sort(arrayDayAscSort);
        sconsole_log("538:   POST SORT SCORES ", scores);
        for(var i = 0; i < scores.length; i++) {
            sconsole_log("dump.565:     ",i,"     ",scores[i].day);
        }

        var today = Date.now()
        var epoch_today = days_from_epoch(today);     // KLUDGE: need to pass in tz!
        var DAY_RANGE = [7, -7, 28, 0];
        for (var k = 0; k < DAY_RANGE.length; k++) {
            var out = [], padding = 0;
            var end_day = epoch_today;
            var day_range = DAY_RANGE[k];
            var score0_day = (scores[0] === undefined)  ? 0 : scores[0].day;
            var start_day = (day_range == 0) ? (score0_day - 1) : end_day - day_range + 1;
            var last_day = start_day;       // last data item
            var final_day;      // to detect completely out of range
            sconsole_log("538:   SCORE FILTER ..... start_day=",start_day, "  last_day=",last_day, " end_day=",end_day," scores=",scores);

            // adjust for one week data, need to pad it to end on Sat
            //
            if ((day_range === 7)) {
                // display the week that contains TODAY
                //
                var day_of_week = (end_day + 4) % 7;      // find out wk day for today
                end_day = epoch_today;
                //padding = 6 - day_of_week;      // pad it so it ends on Sat

                //start_day = start_day + padding;
                start_day = epoch_today - day_of_week - 1;
                end_day = start_day + 7;
                last_day = start_day;   
                sconsole_log("538:      THIS WEEK SCORE..... today=",epoch_today, " start_day=",start_day, "  end_day=",end_day, " day_of_week=", day_of_week, " padding=",padding);
            }

            // adjust for last full week data
            //
            if ((day_range === -7)) {
                // display the week that contains TODAY
                //
                var day_of_week = (epoch_today + 4) % 7;      // find out wk day for today
                padding = 0;

                //end_day = epoch_today - (day_of_week + 2);
                //start_day = end_day - 7;
                start_day = epoch_today - day_of_week - 1 - 7;
                end_day = start_day + 7;
                last_day = start_day;   
                sconsole_log("591:      LAST WEEK SCORE..... today=",epoch_today, " start_day=",start_day, "  end_day=",end_day, " day_of_week=", day_of_week, " padding=",padding);
                day_range = 7;
            }

            var cnt = 0;
            for (var i = 0; i < scores.length; i++) {
                var score = scores[i];
                if(score.day > end_day) {
                    sconsole_log("613:         END     ",i,"    score.day=",score.day, "  start_day=",start_day, " end_day=", end_day, "  last_day=",last_day);
                    // actual data is past relevant range
                    //
                    //var delta = score.day - last_day - 1;
                    //var delta = score.day - last_day;
                    //var delta = start_day - last_day;
                    /*
                    var delta = end_day - last_day + 1;
                    for(var j = 1; j < delta; j++) {
                        out.push(0);        // day with no score gaps
                        cnt = cnt + 1;
                        sconsole_log('        --=', last_day + j);
                    }
                    */
                    break;
                } else if(score.day > start_day) {
                    sconsole_log("620:         ZONE    ",i,"    score.day=",score.day, "  start_day=",start_day, " end_day=", end_day, "  last_day=",last_day);
                    var delta = score.day - last_day;
                    for(var j = 1; j < delta; j++) {
                        out.push(0);        // day with no score gaps
                        cnt = cnt + 1;
                        sconsole_log('        ---', last_day + j);
                    }
                    out.push(score.score);
                    cnt = cnt + 1;
                    sconsole_log('            ', score.day);
                    last_day = score.day;
                } else {
                    //sconsole_log("633:         ....    ",i,"    score.day=",score.day, "  start_day=",start_day, " end_day=", end_day, "  last_day=",last_day);
                }
                final_day = score.day;
            }

            if(final_day < end_day) {
                padding = end_day - final_day;        // actual data less than end, need to pad
            }
            if(final_day < start_day) {
                padding = 7 - cnt;        // zero recent activity, show all 0's
            }
            for (var j = final_day+1; j < final_day+padding+1; j++) {
                out.push(0);        // pad with zero
                sconsole_log('       pad  ', j);
            }

            // if zero data points, fill it with something
            //
            if(out.length === 0) {
                for (var j = 0; j < day_range ; j++) {
                    out.push(0);
                    sconsole_log('       newbie  ', j);
                }
            }

            // insert partial day score (Scores) --- can we do this at the server?
            //out.push(scores.end_score)

            // ANON DEMO MODE:  Display random non-zero stuff
            //
            //if(INFO.anon_mode === true) {
            if ((INFO.anon_mode === true) || (padding == 7)) {
                out = [];
                for (var j = 0; j < day_range ; j++) {
                    var val = Math.floor(Math.random() * 14) * 10;
                    out.push(val);
                }
            }

            if ((day_range > 0) || ((day_range === 0) && (out.length >= 28))) {
                // skip the "all_time" chart if less than 4 weeks of data
                //
                var oscore = {}
                oscore.title = DAY_RANGE[k];
                oscore.data = out;
                all_scores.push(oscore);
                sconsole_log('557:     RANGE=',DAY_RANGE[k],'   PUSH  ', oscore);
            }
        }

        setDailyScores(all_scores);
        setRefresh(Date.now());
    }



    // read and process daily score
    //
    const setupScoreData = () => {

        /*
        if ((INFO.db_scores === null) || (INFO.db_scores === undefined)) {
            setTimeout(()=> {
                setupScoreData();
            },  CONSTS.DB_RECHECK_INTERVAL);
            return;
        }
        */

        if (INFO.db_scores === null) {
            var user_key = makeUserKey(INFO.email, "setupScoreData.1023");
            var user_hash = "usr:"+user_key;
            ReadStateData(user_hash)
            .then(scores => {
                INFO.db_scores = processStateItems("scores", scores);
                console.log("dash.532: ********  SECOND READ OF User Scores =", INFO.db_scores, " scores=",scores);
                processScoreDisplay();
            })
        } else {
            INFO.db_scores = processStateItems("scores", INFO.db_scores);
            processScoreDisplay();
        }
    }


    const handleNewsEvent = () => {
        //console.log("dash.1097:  Update NEW Event =",INFO.db_news);

        setNews(INFO.db_news);    // note: this drives leaderboard & video-of-day
    }


    const handleHealthLight = () => {
        //console.log("dash.601:  Update health light =",INFO.health_light_color);
        setHealthLightColor(INFO.health_light_color);
    }

    // overloading <Wait> to show System Warning Message
    //     - triggered by disptach.event("show_warning")
    //
    const handleShowWarning = event => {
        GATag("Dashboard", "Warning.Show", "", 0);		 // (cat, act, lab, val)
        console.log("menu.151:  SHOW WARNING showWait=",ShowWait);
        setWarning(INFO.warning_message)
        INFO.bug_report = "";
        if(ShowWait === false) {
            setShowWait(true);
        }
    }

    const handleDismissWait = event => {
        console.log("menu.160:  DISABLE WAIT event=",event);
        if(ShowWaitSpinner === false) {
            setShowWait(false);   // DISALBE AUTO DISMISS?
        }
    }

    const handleDismissPWA = event => {
        console.log("menu.160:  HIDE PWA Notice event=",event);
        setShowPWA(false);
    }


    const handleStopGame = (mode) => {
        GATag("Dashboard", "Game.Stop", "", 0);		 // (cat, act, lab, val)
        console.log("stop_replay_game.746:  GAME STOP DETECTED  mode=", mode);
        //setGameStarted(false);
        //INFO.sidebar_width = CONSTS.SIDEBAR_SMALL_WIDTH;
    }


    const handleMenu = event => {
        console.log("menu.97:  display menu from hamburger");
        //auth.firebase_logout("/splash", State, setState);
        //auth.logout("/splash", State, setState);
        //setStartDisplay(false);
        setRefresh(Date.now());
    }


    const handleAction1 = (event) => {
        GATag("Dashboard", "Today.Entry", "", 0);		 // (cat, act, lab, val)
        console.log("setting.958:  REACHED HANDLE TODAY()");
        props.Action("today");
    }

    const handleAction2 = (event) => {
        GATag("Dashboard", "Analyze.Entry", "", 0);		 // (cat, act, lab, val)
        console.log("setting.962:  REACHED HANDLE ANALYZE()");
        props.Action("analyze");
    }

    const handleAction3 = (event) => {
        GATag("Dashboard", "Refresh.Entry", "", 0);		 // (cat, act, lab, val)
        console.log("setting.1024:  REACHED HANDLE REFRESH()");

        setDailyScores([]);
        setLeaderBoards([]);
        //setVideoShowcase([]);
        setVideoShowcase(null);
        setRefresh(Date.now());

        loadUserState(INFO.uid, null)            // read init data from database
        .then(()=>{
            setupDashboardData();
            setRefresh(Date.now());
            console.log("learn.2058:      ........RELOAD DASH COMPLETED");
            //setLearnRedirect(true);
            //setLearnTarget("/menu");
        })
    }

    const handleDrillAction = (drill_hash) => {
        GATag("Dashboard", "Drill.Entry", drill_hash, 0);		 // (cat, act, lab, val)
        console.log("setting.1116:  REACHED HANDLE_DASHBOARD_DRILL()....",drill_hash);

        props.DrillAction(drill_hash);
    }


    const handleLeaderExpandAction = () => {
        GATag("Dashboard", "Leader.Expand", LeaderExpandMode, 0);		 // (cat, act, lab, val)
        if(LeaderExpandMode === false) {
            setLeaderExpandMode(true);
        } else {
            setLeaderExpandMode(false);
        }
    }

    const handleNewsExpandAction = () => {
        GATag("Dashboard", "News.Expand", NewsExpandMode, 0);		 // (cat, act, lab, val)
        if(NewsExpandMode === false) {
            setNewsExpandMode(true);
        } else {
            setNewsExpandMode(false);
        }
    }


    const toggleMenuDrawer = (open) => (event) => {
        GATag("Dashboard", "Menu.Entry", "", 0);		 // (cat, act, lab, val)
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setMenuDrawerOn(open);
    };

    const toggleSettingDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        //console.log("setting.449:  Open setting drawer");
        setSettingDrawerOn(open);

    };



            //<Fade in={State.authed} timeout={{enter: 1000, exit: 2000}}>
            //</Fade>
                        //<Menus Toggle={toggleMenuDrawer} Action={handleAction} {...props} />
                            //<Container id="date"  className={classes.org_text}>{INFO.db_org.name.toUpperCase()}</Container>
                            //<Container id="date"  className={(VerticalMode === true) ? classes.vertical_org_text : classes.horizontal_org_text}>{OrgName}</Container>
    return (
        <React.Fragment>

            { ShowTutorial && <Tutorial  Show={Show} Dismiss={handleDismissTutorial}/> }
            { ShowWait && <Wait Warning={Warning} Dismiss={handleDismissWait} ShowSpinner={ShowWaitSpinner} /> }
            { ShowPWA && <NoticePWA Type={NoticeType} Dismiss={handleDismissPWA}
                                Style={{position: "absolute", top: "50px", left: "0px"}} />}

                <Container id="menu_root" className={classes.menu_root}>

                    <Container id="top_bar"  className={classes.top_bar}>
                        <div id="health_light" style={{background: HealthLightColor}} className={Classes.health_light} />
                        <Button id="setting_btn" className={Classes.bug_icon} onClick={props.ToggleSetting} >
                            <Avatar id="avatar7" Image={Photo} />
                        </Button>

                        <Container className={classes.top_center}>
                            <Container id="date"  className={(props.VerticalMode === true) ? classes.vertical_org_text : classes.horizontal_org_text}>{OrgName}</Container>
                        </Container>

                        <Container className={classes.top_center}>
                            <Container id="date"  className={classes.org_text}>{CurrentScore}</Container>
                        </Container>

                        <Button id="menu_btn" className={Classes.bug_icon} onClick={toggleMenuDrawer(true)} >
                            <FontAwesomeIcon 
                                className={Classes.logo_icon}
                                icon={faBars}
                                style={{ fontSize: "1.7rem"}} />
                        </Button>
                    </Container>

                <Container id="dashboard_container" className={(props.VerticalMode === true) ? classes.vertical_dashboard_container : classes.horizontal_dashboard_container} >
                  <Container id="dashboard_inner" className={classes.dashboard_container} >

                    <Container id="score_board" className={[classes.graph_container, classes.graph_20h, (props.VerticalMode && classes.graph_90w) ].join(' ')} >
                        <DailyScore Scores={DailyScores} Height={ScoreBoardHeight} />
                    </Container>

                    <Container id="video_board" className={[classes.graph_container, classes.graph_20h, (props.VerticalMode && classes.graph_90w) ].join(' ')} >
                        <VideoFeed Videos={VideoShowcase} News={News} Height={VideoBoardHeight} DrillAction={handleDrillAction} Title="DRILL VIDEO OF THE DAY" />
                    </Container>

                    <Container id="leader_board" className={[classes.graph_container, 
                                            classes.graph_leader, 
                                            (LeaderExpandMode && classes.graph_90h),
                                            (props.VerticalMode && classes.graph_90w) ].join(' ')} >
                        <LeaderBoard Leaders={LeaderBoards} ExpandMode={LeaderExpandMode} Height={LeaderBoardHeight} DrillAction={handleDrillAction} Expand={handleLeaderExpandAction}  />
                    </Container>

                    <Container id="news_feed" className={[classes.graph_container, 
                                            classes.graph_20h, 
                                            (NewsExpandMode && classes.graph_90h),
                                            (props.VerticalMode && classes.graph_90w) ].join(' ')} >
                        <NewsFeed Leaders={LeaderBoards}  ExpandMode={NewsExpandMode} Height={NewsBoardHeight} DrillAction={handleDrillAction} Expand={handleNewsExpandAction}  />
                    </Container>


                    { false && <Container id="game_replay" className={[classes.graph_container, classes.graph_20h, (props.VerticalMode && classes.graph_90w) ].join(' ')} >
                        <Game 
                            Type="simple" 
                            Replay={true}
                            GameClicks={GameClicks}
                            Scheme={GameScheme} 
                            Fingers={GameFingers} 
                            Finished={handleStopGame} 
                            //GameStarted={GameStarted}
                            //GameCnt={GameCnt}
                            />
                    </Container>}


                    <Drawer id="menu_drawer"  anchor={"right"} open={MenuDrawerOn} onClose={toggleMenuDrawer(false)}>
                        <Menus Toggle={toggleMenuDrawer} {...props} />
                    </Drawer>

                    {/*<Drawer id="setting_drawer" anchor={"left"} open={SettingDrawerOn} onClose={toggleSettingDrawer(false)}>
                        <Settings Version={Version} Toggle={toggleSettingDrawer} />
                    </Drawer>*/}

                  </Container>
                </Container>


                {(props.VerticalMode === true) ?
                    <Container id="bottom_bar"  className={classes.bottom_bar}>
                        <QuickLaunch 
                            Icon1={faSun} 
                            Icon2={faFilm} 
                            Icon3={faRedoAlt} 
                            Action1={handleAction1} 
                            Action2={handleAction2} 
                            Action3={handleAction3} />
                    </Container>
                :
                    <Container id="right_bar"  className={classes.right_bar}>
                        <QuickLaunch 
                            Icon1={faSun} 
                            Icon2={faFilm} 
                            Icon3={faRedoAlt} 
                            Action1={handleAction1} 
                            Action2={handleAction2} 
                            Action3={handleAction3} />
                    </Container>
                }

            </Container>

            {/*renderRedirect()*/}
        </React.Fragment>
    )
}

//export default withRouter(Dashboard)
